import { PlatformUtility } from '../../utils/platform-utility';
import { h, render } from 'preact';

import { getSelectorAttribs } from '../../utils/renderer-utils';
import { SelectorTuple } from '../constants/selectors';

import { ResultsPageFilters } from '../components/results/results-page-filters.component';
import { ResultsMapMobileToggle } from '../components/results/results-map-mobile-toggle.component';
import { ResultsCategoryToggle } from '../components/results/results-category-toggle.component';
import { ResultsOneBrokerNotif } from "../components/results/results-one-broker-notif.component";
import { PropertiesMap } from '../components/commons/properties-map.component';

export function renderComponents() {
  if (PlatformUtility.isOnClient()) {
    // console.log('Running on client');

    const SELECTORS: SelectorTuple[] = [
      {
        name: 'hi-results-category-toggle',
        component: ResultsCategoryToggle
      },
      {
        name: 'hi-results-map-mobile-toggle',
        component: ResultsMapMobileToggle
      },
      {
        name: 'hi-results-page-filters',
        component: ResultsPageFilters
      },
      {
        name: 'hi-results-one-broker-notif',
        component: ResultsOneBrokerNotif
      },
      {
        name: 'hi-properties-map',
        component: PropertiesMap
      },
    ];
    
    SELECTORS.forEach((selector) => {
      let targets = document.querySelectorAll(selector.name);
  
      targets.forEach((target) => {
        //get attributes from pug level
        const attributes = getSelectorAttribs(target.attributes);
  
        //create VDOM of component with attributes
        let componentVDOM = h(selector.component, attributes);
        render(componentVDOM, target, target.children[0]);
      });
    });
  }
}